import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface Theme {     
   myTools?: string;
   footerSpan?: string;
   mytoolsCardbottom?: string;
   myToolsCard?: string;
   myToolCardData?: string;
   headerBorder?: string;
   greyborder? : string;
   bannerSubHeading?: string;
   seeMoreButton?: string;
   headerBgColor?: string;
   headerFontColor?: string;
    headerFontGreyColor?: string;
    headerButtonBackground?:string;
    primaryBackground?: string;
    gradientStyle?: string;
    brandingTurnbg?: string;
    notFound?:string;
    iconsBackground?: string;
    enhanceHeader?: string;
    enhanceHeaderLower?: string;
    iconsBackgroundTool?: string;
    formArea?: string;
    feild?: string;
    formHelpingSpan?: string;
    formspanhead?: string;
    formPlaceHolder?: string;
    inputHeading ?: string,
    speedTestUrlLinkText?: string,
    speedTestUrlLinkSpan?: string,
    leadFormPopupInputBg?: string,
    leadFormPopupInputBorder?: string,
    formInputTextColor?: string
    
    // updateed desgine variable
    secondary: string;
    primary: string;
    color: string;
    cardBorderColor?: string;
    buttonBackground?: string;
    buttonTextColor?: string;  
    border: string;
    icon?: string;  
    aiChatbackground?: string;
    Darkone?: string;
    bannerHeading?: string;
    bannerInputbg?: string;
    inputText?: string;
    cardBackground?: string;
    formHolders?: string;
    mainHeadingOne?: string
    SubHeadingSubTwo?: string
    hedaerLinksMain?: string
    headerInputPlacegolder?: string
    headerButtons?: string
    headerButtonshero?: string
    heroSectionBackgroundGradient?: string
    hedaerBackground?: string
    heroSectionBackground?: string
    headerButtonsBackground?: string
    flagButtonColor?: string,
    flagButttonBackground?:string,
    headerButoonsBorder?: string,
    imgGradient?: string
    heroSectionImage?: string
    headerButtonBackGradient?: string
    requirementTabColor?: string
    reIcon?: string
    reHeading?: string
    reText?: string
    reTabBorder?: string
    templateCardbg?: string
    iconBackground?: string
    templateHeading?: string
    templateText?: string
    templateButtonbg?: string
    templateButtonTxt?: string
    mainbg?: string,
    templateTabIconColor?: string,
    templateTabText?: string,
    templatetabbg?: string,
    powerfullFeatureGradient?: string,
    footerH3?: string,
    footerli?: string,
    noSpam?: string,
    footerBgg?: string
    hoverbgcolor?: string,
    animationGradient?: string,
    FeaturesCardVar?: string,
    leadPopupHeading?: string,
    leadPopupSubHeading?: string
    heroSectionInputBg?: string,
    headerTextAreaBg?: string, 
    hoverBackground?:string, 
    builderHeaderLink?: string,
    builderHeaderLinksaved?: string,
    chatIconcolors?: string,
    chatRightBarIcon?: string,
    aichatBorderColor?: string,
    aiChatTextBackground?: string,
    aiGeneratedText?: string,
    userTextbg?: string,
    chatParentDivBorder?:string,
    chatRightBackground?: string,
    aiChatInputBorder?: string,
    aiChatInputBg?: string,
    chatInputIconBg?: string,
    brandingMainBd?: string,
    brandingdrag?: string,
    brandingdragor?: string,
    brandingdragp?: string,
    brandingdragspan?: string,
    brandingUrl?: string,
    brandingBorder?: string,
    brandingBorderLogo?: string,
    pickerOne?: string,
    aiChatHeaderBg?: string,
    chatBoatIcon?: string,
    successfullyBrandingbg?: string,
    brandingfinal?: string,
    brandingHeading?: string,
    subHeading?: string,
    brandingParentConatiner?: string,
    brandingChildConatiner?: string,
    bradingInputbg?: string,
    bradingdashbg?: string,
    formInput?: string,
    formspanTitle? : String;
    background: string,
    fsAnalyze?: string,
    analyzevissec?: string,
    analyzecardbg?: string,
    analyzeCardBorder?: string,
    analyzebg?:string,
    analyzeLeftCard?: string,
    datecardbg?: string,
    flagButtonBorder?: string,
    leadFromInput?: string,
    leadformInputBorder?: string,
    leadFromInputLabel?:string,
    leadFormHeading?: string,
    leadFormSubHEading?: string,
    leadFormPopUp?: string,
    leadFormPopUpInputBorder?: string
    enhanceOption?: string
    enoptionbg?:string
    promptGallery?: string
    tableBg?: string
    tableBorder?:string
    tableHeaderText?: string
    unactivCard?: string
    leadFormHeadingSubContent?: string
    overviewPicturediv?: string
    enhanceMainHeading?: string
    enhanceSubHeading?: string
    loginPopupbg?: string
    loginPopupHeading?: string
    loginPopupSubHeading?: string
    userDetailsLoader?: string
    planBackButton?: string
    viewMoreHeading?: string
    viewMoreSubHeading?: string
    planSection?: string
    viewPlanBorder?: string
    viewPlanBorderIn?: string
    yourDetailsCard?: string
    planTags?: string
    count?: string
    subCount?: string
    subFeatures?: string
    planPg?: string
    usageSection?: string
    toolHubLoader?: string
    toolHubLoaderHeading?: string
    toolHubLoaderSubHeading?: string
    toolLoaderBordaer?: string
    heroSectionInputIcon?: string
    heroSectionInputIconBorder?: string
    heroSectionInputIconBg?: string
    loaderBorderColor?: string
    cardTabBorder?: string
    heroEnhannceText?: string
    nothingToPreview?: string
    headerLinks?:string
    heroLogo?: string
    smartToolImg?: string
    tooliIconBackground?: string
    userCountIcon?: string
    faqQues?: string
   faqans?: string
   previewAnalyz?: string
   activeLink?: string
   seIcon?: string
   leadformBordre?: string
   noPlans?: string
   noInvoices?: string
   brandingBG?: string
   dataToolr?: string
   dataToolLabe?: string
   appDataBorder?: string
   toolDataHeaderText?: string
   tabelLabelData?: string
   toolDataIcon?: string
   analystHd?: string
   noData?: string
   monthlyYearly?: string
   appDataInputbd?: string
   promptGalleryIconBg?: string
   myToolvar?: string
   liveleadforminputbg?: string
   toggleUncheckedColor?: string
   toggleCircleColor?: string
   iconbgg?: string
  }
  
  
  const defaultTheme: Theme = {

    toggleUncheckedColor: '#e9e9e9',
     toggleCircleColor: '#adadad',
    analystHd:'#222',
    toolDataIcon: '#666',
    tabelLabelData:'#666',
    toolDataHeaderText: '#444',
    appDataBorder: '#eaeaea',
    dataToolLabe: '#f9f9f9',
    dataToolr:'#fff',
    leadformBordre: '#eaeaea',
    myTools: '#fff9fa',
    footerSpan: '#667085',
    mytoolsCardbottom: '#ffe7e8',
    myToolsCard: 'white',
    myToolCardData: '#444444',
    headerBorder: '#E1E1E1',
    greyborder: '#eoeoeo',
    bannerSubHeading: '#222',
    seeMoreButton: '#fb5f65',
    headerBgColor: '#FFE7E8', 
    headerFontColor:'#FB5F65',
    headerFontGreyColor:'#848484',
    headerButtonBackground:'#FFFFFF',
    primaryBackground: 'white',
    brandingTurnbg: '#FFE7E8',
    notFound: '#f6f4f3',
    iconsBackground:'#f9f5f2',
    enhanceHeader:'#ffcaca',
    enhanceHeaderLower:'rgba(245, 238, 238, 0.5)',
    iconsBackgroundTool: '#ffe7e8',
    formArea: 'white',
    feild: 'rgba(62, 154, 220, 0.1)',
    formHelpingSpan: '#666666',
   formspanhead: '#284f67',
    formPlaceHolder: '#444444',
    inputHeading: '#444444',
    speedTestUrlLinkText:'#444444',
    speedTestUrlLinkSpan:'#222222',
    leadFormPopupInputBg: 'transparent',
    leadFormPopupInputBorder: '#eff0f6',
    formInputTextColor: '#444444',
    // updateed desgine variable
    primary: '#fff9fa', // Light Pink
    secondary: '#fef6f4', // Light Red
    cardBackground: 'transparent', 
    border: '#e1e1e1', 
    color: '#222222', 
    icon: '#62696d', // Dark Gray
    aiChatbackground: '#ffffff', // White
    Darkone: '#fd4b92',
    bannerHeading: '#444',
    bannerInputbg: 'white',
    inputText: '#000', // Very Dark Gray (Almost Black)
    cardBorderColor: '#fb5f65', // Light Red
    buttonBackground: '#fb5f65', // Light Red
    buttonTextColor: '#ffffff', // White
    formHolders: '#f0f0f0',
    background: '#ffffff', // White
    userTextbg: '#f5f5f5', // Light Red
    hoverBackground:'#f0efef',
    mainHeadingOne:'#111111',
    SubHeadingSubTwo:'#444444',
    hedaerLinksMain: '#3c3c43',
    headerInputPlacegolder:'rgba(115, 113, 113, 50%)',
    headerButtons: '#222222',
    headerButtonshero: '#444',
    heroSectionBackgroundGradient:'#ffffff',
    hedaerBackground:'linear-gradient(90deg, rgba(248, 248, 248, 0.7) 0%, rgba(245, 245, 245, 0.7) 100%)',
    heroSectionBackground: '#ffffff',
    headerButtonsBackground:'#f5f5f5',
    flagButtonColor: '#333333',
    flagButtonBorder:'#e9e9ee',
    flagButttonBackground: 'rgba(248, 249, 250, 1)',
    headerButoonsBorder:'#cfcfcf',
    imgGradient: 'linear-gradient(135deg, #ffffff 0%, #000000 100%);',
    heroSectionImage: 'https://dlvkyia8i4zmz.cloudfront.net/2nXQN51nTwK8eKQwSdie_Clip_path_group.svg',
    headerButtonBackGradient: 'linear-gradient(90deg, #FFEFF0 -6.79%, #FFECF8 106.24%)',
    requirementTabColor:'rgba(245,245,245,1)',
    reIcon: 'rgba(41,45,50,1)',
    reHeading: 'rgba(34,34,34,1)',
    reText: 'rgba(102,102,102,1)',
    reTabBorder:'#cfcfcf',
    templateCardbg:'rgba(207,207,207,1)',
    brandingBG: `linear-gradient(282.05deg, #FEDFE1 6.57%, #FFD8F0 92.35%)`,  
    iconBackground:'linear-gradient(282.05deg, rgba(254, 223, 225, 0.6) 6.57%, rgba(255, 216, 240, 0.6) 92.35%)',
    tooliIconBackground: '#f5f5f5',
    templateHeading:'#222222',
    templateText:'#666666',
    templateButtonbg:'rgba(245,245,245,1)',
    templateButtonTxt:'rgba(34,34,34,1)',
    mainbg:'#ffffff',
    templateTabIconColor: 'rgba(41,45,50,1)',
    templateTabText: 'rgba(68,67,67,1)',
    templatetabbg: 'rgba(245,245,245,1)',
    powerfullFeatureGradient: 'https://dlvkyia8i4zmz.cloudfront.net/GgajQmC6RGSghweBR3Ql_features_bg.svg',
    footerH3: 'rgba(38,38,38,1)',
    footerli: '#222222',
    noSpam: 'rgba(136,136,136,1)',
    footerBgg: 'linear-gradient(90deg, rgba(248, 248, 248, 0.7) 0%, rgba(245, 245, 245, 0.7) 100%)',
    hoverbgcolor: 'rgba(255, 255, 255, 1)',
    animationGradient:'linear-gradient(95.48deg, #ffd8f0 0%, #fedfe1 100%)',
    FeaturesCardVar:'rgba(207, 207, 207, 0.9882)',
    leadPopupHeading: '#222222',
    leadPopupSubHeading: '#444444',
    heroSectionInputBg:'white',
    headerTextAreaBg:'#ffffff',
    builderHeaderLink:'#444444',
    builderHeaderLinksaved:'#444',
    chatIconcolors:'#666666',
    chatRightBarIcon:'#444444',
    gradientStyle: `linear-gradient(360deg, rgba(251, 95, 101, 0.15) 0%, rgba(255, 58, 182, 0.15) 21.38%, rgba(255, 255, 255, 0.15) 46.54%)`,
    aichatBorderColor:'#eaeaea',
    aiChatTextBackground: 'transparent',
    aiGeneratedText: 'black', // Black
    chatParentDivBorder:'#ffeff0',
    aiChatInputBorder: '#e3e7ea',
    aiChatInputBg: 'transparent',
    chatInputIconBg:'#f9f9f9',
    brandingMainBd:'rgba(233, 233, 233)',
    brandingdrag: '#666666',
    brandingdragor: '#444',
    brandingdragp: '#666',
    brandingdragspan:  '#666',
    brandingUrl:'#292d23',
    brandingBorder:'#eaeaea',
    brandingBorderLogo: '#939292',
    pickerOne:'black',
    aiChatHeaderBg: '#ffffff',
    chatRightBackground: 'rgba(239, 239, 239, 0.2)',
    chatBoatIcon: 'white',
    successfullyBrandingbg:'#eee8e8',
    brandingfinal:'#444444',
    brandingHeading: '#444',
    subHeading: '#666',
    brandingChildConatiner:'#ffffff',
    bradingInputbg:'#f5f5f5',
    bradingdashbg:'white',
    formInput: '#f5f5f5',
    formspanTitle: '#444444',
    fsAnalyze:'https://dlvkyia8i4zmz.cloudfront.net/sDdg38p3S9ibHWPLEQ4e_bg__3_.svg',
    analyzevissec:'rgba(255, 255, 255, 0.6)',
    analyzecardbg:'#fff',
    analyzeCardBorder:'#fff',
    analyzebg:'#fcfcfc',
    analyzeLeftCard:'#fafafa',
    datecardbg:'#ffffff',
    leadFromInput:'#f5f5f5',
    leadformInputBorder:'#eaeaea',
    leadFromInputLabel:'linear-gradient(282.05deg, rgba(251, 95, 101, 0.1) 6.57%, rgba(255, 58, 182, 0.1) 92.35%)',
    leadFormHeading: '#444',
    leadFormSubHEading: '#666666',
    leadFormPopUp:'#ffffff',
    leadFormPopUpInputBorder:'#eaeaea',
    enhanceOption:'#222',
    enoptionbg:'#f5f5f5',
    promptGallery:'#ffffff',
    tableBg:'#ffffff',
    tableBorder: '#efefef',
    tableHeaderText:'#444444',
    unactivCard:'#fafafa',
    leadFormHeadingSubContent: '#444444',
    overviewPicturediv: 'transparent',
    enhanceMainHeading: '#222222',
    enhanceSubHeading: '#444444',
    loginPopupbg:'white',
    loginPopupHeading: '#222',
    loginPopupSubHeading: '#444444',
    userDetailsLoader: 'https://dlvkyia8i4zmz.cloudfront.net/FPI7dO2Tl1tN7ZUGSZAb_User_empty.svg',
    planBackButton:'#222222',
    viewMoreHeading:'#222',
    viewMoreSubHeading:'#666666',
    planSection:'linear-gradient(282.05deg, #FEDFE1 6.57%, #FFD8F0 92.35%)',
    viewPlanBorder:'#eaeaea',
    viewPlanBorderIn:'rgba(0, 0, 0, 0.1)',
    yourDetailsCard: '#ffffff',
    planTags: '#444444',
    count:'#222222',
    subCount:'#444444',
    subFeatures:'#222222',
    planPg:'#fcfcfc',
    usageSection:'#ffffff',
    toolHubLoader:'https://dlvkyia8i4zmz.cloudfront.net/6FwJ5QyDSNKAZ13Cn1GC_Frame_1618872945.svg',
    toolHubLoaderHeading:'#444444',
    toolHubLoaderSubHeading:'#666666',
    toolLoaderBordaer: '#cfcfcf',
    heroSectionInputIcon:'#222222',
    heroSectionInputIconBorder:'#cfcfcf',
    heroSectionInputIconBg: '#ffffff',
    loaderBorderColor:'#cfcfcf',
    cardTabBorder:'#cfcfcf',
    heroEnhannceText: '#222222',
    nothingToPreview: 'https://dlvkyia8i4zmz.cloudfront.net/KJ3Z5WmTLqFNI4Q34DUs_Group_1321316817.svg',
    headerLinks:'#444444',
    heroLogo: 'https://dlvkyia8i4zmz.cloudfront.net/tool_builder/1748250195351_Group_1321316933.svg',
    smartToolImg: 'https://dlvkyia8i4zmz.cloudfront.net/KPD8TXjESyyuw0szgymw_Group_1321316722__2_.svg',
    userCountIcon: '#fd4e8b',
    faqQues:'#222222',
    faqans:'#444444', 
    previewAnalyz:'linear-gradient(298.16deg, rgba(251, 95, 101, 0.08) 10.43%, rgba(255, 58, 182, 0.08) 88.71%)',
    activeLink:'#ff3ab6',
    seIcon: '#666666',
    noPlans: 'https://dlvkyia8i4zmz.cloudfront.net/0lAeeSeTQQaEx5z09aC7_Group_1321316911__1_.svg',
    noInvoices:'https://dlvkyia8i4zmz.cloudfront.net/lofJnUgRHiFwMTWlVB0d_Group_1321316911__2_.svg',
    noData: 'https://dlvkyia8i4zmz.cloudfront.net/Arx0ELQSRoWUz8qTnp9T_Group_1321316801_6__1_.svg',
    monthlyYearly: '#343434',
    appDataInputbd: '#f5f5f5',
    promptGalleryIconBg: `radial-gradient(31.91% 103.98% at 0% 46.15%, rgba(255, 58, 182, 0.05) 0%, rgba(251, 95, 101, 0.05) 40%, rgba(255, 255, 255, 0.05) 100%)`,
    myToolvar: '#fff',
    liveleadforminputbg: '#f5f5f5',
    iconbgg:'linear-gradient(282.05deg, rgba(254, 223, 225, 0.6) 6.57%, rgba(255, 216, 240, 0.6) 92.35%)',
    };
    
  const darkTheme: Theme = {
    iconbgg:'#2b2b2b',
    toggleUncheckedColor: '#454545',
    toggleCircleColor: '#757575',
    liveleadforminputbg: '#2c2c2c',
    myToolvar: '#1b1b1b',
    color: '#C4C4C4', // White
    promptGalleryIconBg: `
    radial-gradient(31.91% 103.98% at 0% 46.15%, rgba(255, 58, 182, 0.05) 0%, rgba(251, 95, 101, 0.05) 40%, rgba(36, 36, 36, 0.05) 100%)`,
    appDataInputbd: '#2c2c2c',
    monthlyYearly: '#eaeaea',
    noData: 'https://dlvkyia8i4zmz.cloudfront.net/0GyCfdBJRvqPSthWdoq4_Group_1321316844.svg',
    analystHd:'#fafafa',
    toolDataIcon: '#888',
    tabelLabelData:'#c4c4c4',
    toolDataHeaderText: '#eaeaea',
    appDataBorder: 'rgba(255, 255, 255, 0.1)',
    dataToolLabe: '#242424',
    dataToolr:'#111',
    brandingBG: '#111',
    leadformBordre: 'rgba(255, 255, 255, 0.1)',
    myTools: '#252525',
    footerSpan: 'white', 
    mytoolsCardbottom: '#191919', 
    myToolsCard: '#1e1e1e',
    myToolCardData: '#ffffff',
    headerBorder: '#2b2b2b',
    greyborder: '#eoeoeo',
    bannerSubHeading: '#e7e7e7',
    seeMoreButton: 'white',
    headerBgColor: '#191919', 
    headerFontColor:'#FC787C',
    headerFontGreyColor:'#848484',
    headerButtonBackground:'#0D0D0D',
    primaryBackground:'#111',
    activeLink:'#ff3ab6',
    brandingTurnbg: '#252121',
    notFound: '#1b1b1b',
    iconsBackground:'#414141',
    enhanceHeader:'#4e0000',
    enhanceHeaderLower:'rgba(26, 26, 26, 0.5)',
    iconsBackgroundTool: '#191919',
    formArea: '#252525',
    feild: '#121212',
    
    formHelpingSpan: '#666666B3',
   
    formspanhead: '#efefef',
    formPlaceHolder: '#444444',
    inputHeading: '#e4e4e4',
    speedTestUrlLinkText:'white',
    speedTestUrlLinkSpan:'white',
     leadFormPopupInputBg: 'transparent',
     leadFormPopupInputBorder: '#6d6d6d',
    formInputTextColor: '#efefef',
   
    // updateed desgine variable
    primary: '#1b1b1b',
    secondary: '#fb5f65', 
    
    border: 'white', // Solid Light Red
    cardBorderColor: '#444444', // Dark Gray
    buttonBackground: '#fb5f65', // Light Red
    buttonTextColor: '#E0E0E0', // Light Gray
    cardBackground: '2px solid #fc5f66', // Solid Light Red
    icon: '#fb5f65', // Light Red
    aiChatbackground: '#1f1f1f', // Very Dark Gray (Almost Black
     bannerHeading: '#eaeaea',
    bannerInputbg: '#0d0d0d',   
    inputText: '#fff', 
    formHolders: '#3e3e3e',
    hoverBackground:'#3d3d3d',
    mainHeadingOne:'#fafafa',
    SubHeadingSubTwo:'#eaeaea',
    hedaerLinksMain: '#f8f8f8',
    headerInputPlacegolder:'#eoeoeo',
    headerButtons: '#e0e0e0',
    headerButtonshero: '#eaeaea',
    heroSectionBackgroundGradient:'#000000',
    hedaerBackground:'linear-gradient(90deg, rgba(248, 248, 248, 0.08) 0%, rgba(245, 245, 245, 0.08) 100%)',
    heroSectionBackground: ' linear-gradient(69.41deg, rgba(29, 29, 29, 0) -1.04%, #111111 62.46%)',
    headerButtonsBackground:'#242424',
    flagButtonColor: '#f8f8f8',
    flagButttonBackground: '#3a3a3a',
    headerButoonsBorder:'#3a3a3a',
    imgGradient: 'linear-gradient(to top right, rgba(29, 29, 29, 0) 0%, #111111 97.2862%)',
    heroSectionImage: 'https://dlvkyia8i4zmz.cloudfront.net/dtxypkw7R5eTyU3EIX6y_BG__1_.svg',
    headerButtonBackGradient:'linear-gradient(90.29deg, #2D2D2D 0.27%, #202020 99.77%)',
    requirementTabColor:'rgba(30,30,30,1)',
    reIcon: 'rgba(248,2498,248,1)',
    reHeading: 'rgba(248,2498,248,1)',
    reText: 'rgba(197,197,197,1)',
    reTabBorder:'#464646',
    templateCardbg:'rgba(30,30,30,1)',
    iconBackground:'#2C2C2C',
    tooliIconBackground: '#2b2b2b',
    templateHeading:'rgba(248,248,248,1)',
    templateText:'#B4B4B4',
    templateButtonbg:'rgba(41,41,41,1)',
    templateButtonTxt:'rgba(224,224,224,1)',
    mainbg:'#000000',
    Darkone: '#fd4b92',
    templateTabIconColor: 'rgba(248,248,248,1)',
    templateTabText: 'rgba(224,224,224,1)',
    templatetabbg: 'rgba(36,36,36,1)',
    powerfullFeatureGradient: 'https://dlvkyia8i4zmz.cloudfront.net/EFUrGs6TDmeU0yzTwcA6_features_bg__1_.png',
    footerH3: 'rgba(224, 224,224,1)',
    footerli: 'rgba(197,197,197,1)',
    noSpam: 'rgba(224,224,224,1)',
    footerBgg: ' linear-gradient(90deg, rgba(248, 248, 248, 0.08) 0%, rgba(245, 245, 245, 0.08) 100%)',
    hoverbgcolor: 'rgba(245, 245, 245, 1)',
    animationGradient:'#232323',
    FeaturesCardVar:'rgba(70, 70, 70, 0.9882)',
    leadPopupHeading: '#dddddd',
    leadPopupSubHeading: '#eaeaea',
    heroSectionInputBg:'#1e1e1e',
    headerTextAreaBg:'#111111',
    builderHeaderLink:'#e0e0e0',
    builderHeaderLinksaved:'#f8f8f8',
    chatIconcolors:'#e0e0e0',
    chatRightBarIcon:'#fafafa',
    gradientStyle: `linear-gradient(0deg, #1b1b1b, #1b1b1b), linear-gradient(360deg, rgba(251, 95, 101, 0.15) 0%, rgba(255, 58, 182, 0.15) 21.38%, rgba(255, 255, 255, 0.15) 46.54%)`,


    aichatBorderColor: 'rgba(255, 255, 255, 0.1)',
    aiChatTextBackground: '#1b1b1b',
    aiGeneratedText: 'white', // Black
    userTextbg: '#232323', // Dark Gray
    chatParentDivBorder:'#464646',
    chatRightBackground: 'rgba(44, 44, 44, 0.2)',
    aiChatInputBorder: '#1e1e1e',
    aiChatInputBg: '#1b1b1b',
    chatInputIconBg:'#2c2c2c',
    brandingMainBd:'#111111',
    brandingdrag: '#C4C4C4',
    brandingdragor: 'white',
    brandingdragp:'#c4c4c4',
    brandingdragspan:  'white',
    brandingUrl:'white',
    brandingBorder: 'rgba(255, 255, 255, 0.1)',
    brandingBorderLogo: '#939292',
    pickerOne:'#fafafa',
    aiChatHeaderBg: '#1b1b1b',
    chatBoatIcon: 'black',
    successfullyBrandingbg:'#3b3b3b',
    brandingfinal:'#eaeaea',
    brandingHeading: '#fafafa',
    subHeading: '#c4c4c4',
    brandingParentConatiner:'black',
    brandingChildConatiner:'#1b1b1b',
    bradingInputbg:'#2c2c2c',
    bradingdashbg:'#242424',
    formInput: '#2c2c2c',
    formspanTitle: '#eaeaea',
    background: '#111', // Dark Gray
    fsAnalyze:'rgb(17,17,17)',
    analyzevissec:'#272727',
    analyzecardbg:'#242424',
    analyzeCardBorder: '1px solid rgba(255, 255, 255, 0.1)',
    analyzebg:'#171717',
    analyzeLeftCard:'#111111',
    datecardbg:'#272727',
    flagButtonBorder:'#3a3a3a',
    leadFromInput:'#2c2c2c',
    leadformInputBorder:'rgba(255, 255, 255, 0.1)',
    leadFromInputLabel:'#3e3e3e',
    leadFormHeading: '#eaeaea',
    leadFormSubHEading: '#c4c4c4',
    leadFormPopUp:'#111111',
    leadFormPopUpInputBorder:'1px solid rgba(255, 255, 255, 0.1)',
    enhanceOption:'#eaeaea',
    enoptionbg:'#2c2c2c',
    promptGallery:'#171717',
    tableBg:'#181818',
    tableBorder: '#464646',
    tableHeaderText:'#f8f8f8',
    unactivCard: '#272727',
    leadFormHeadingSubContent: '#efefef',
    overviewPicturediv: '#464646',
    enhanceMainHeading: '#f8f8f8',
    enhanceSubHeading: '#c5c5c5',
    loginPopupbg:'#111111',
    loginPopupHeading: '#fafafa',
    loginPopupSubHeading: '#eaeaea',
    userDetailsLoader: 'https://dlvkyia8i4zmz.cloudfront.net/b8Y42JcQeCUoqdWZ9p0k_User_empty__1_.svg',
    planBackButton:'#e0e0e0',
    viewMoreHeading:'#fafafa',
    viewMoreSubHeading:'#eaeaea',
    planSection:'#111111',
    viewPlanBorder:'#464646',
    viewPlanBorderIn:'#FFFFFF1A',
    yourDetailsCard: '#111111',
    planTags: '#f8f8f8', 
    count:'#f8f8f8',
    subCount:'#e0e0e0',
    subFeatures: '#e0e0e0',
    planPg:'#171717',
    usageSection:'#272727',
    toolHubLoader:'https://dlvkyia8i4zmz.cloudfront.net/fyLxmfLrTiXtgKyeOf2A_Group_1321316806.svg',
    toolHubLoaderHeading:'#f8f8f8',
    toolHubLoaderSubHeading:'#e0e0e0',
    toolLoaderBordaer: '#464646',
    heroSectionInputIconBg: '#242424',
    heroSectionInputIcon: '#f8f8f8',
    heroSectionInputIconBorder:'#464646',
    loaderBorderColor:'#353535',
    cardTabBorder:'#464646',
    heroEnhannceText: '#f8f8f8',
    nothingToPreview: 'https://dlvkyia8i4zmz.cloudfront.net/Yte2rI29R9ub8JYznMNa_Group_1321316818.svg',
    headerLinks:'#eaeaea',
    heroLogo: 'https://dlvkyia8i4zmz.cloudfront.net/xouiq6f5QeSf1FMQi4Rg_Group_1321316910__2_.svg',
   smartToolImg: 'https://dlvkyia8i4zmz.cloudfront.net/mm8QMPOxTuSJTzC0BgJ8_Group_1321316904__1_.svg',
   userCountIcon: '#868686',
   faqQues:'#fafafa',
   faqans:'#eaeaea',
   previewAnalyz:'linear-gradient(298.16deg, rgba(251, 95, 101, 0.08) 10.43%, rgba(255, 58, 182, 0.08) 88.71%)',
   seIcon:'#c4c4c4',
   noPlans: 'https://dlvkyia8i4zmz.cloudfront.net/FkVXw6QMTfOekmXcPer7_Group_1321316912.svg',
   noInvoices:'https://dlvkyia8i4zmz.cloudfront.net/FkVXw6QMTfOekmXcPer7_Group_1321316912.svg'
  };
  
  function addDarkClass(isDark:boolean){
    isDark ? document.documentElement.classList.add('dark'): document.documentElement.classList.remove('dark');
  }

  interface themeInterface{
    theme:Theme,
    themeValue:string
  }
  const storedTheme = localStorage.getItem('theme');
  const initialTheme:Theme = storedTheme === 'dark' ? darkTheme : defaultTheme;

const initialValue:themeInterface={
    theme:initialTheme,
    themeValue:storedTheme ? storedTheme:'light'
}
storedTheme==='dark'?addDarkClass(true):addDarkClass(false);
 const themeSlice = createSlice({
  name: "themeObject",
  initialState: initialValue,
  reducers: {
    toggleTheme: (
      state,
    ) => {
        const newTheme = state.themeValue === 'light' ? darkTheme : defaultTheme;
       
        localStorage.setItem('theme', newTheme === darkTheme ? 'dark' : 'light'); // Store theme in localStorage   
        if(newTheme===darkTheme){
          addDarkClass(true);
          state.themeValue='dark'; 
        }
        else{
          addDarkClass(false);
          state.themeValue='light';
        }
        state.theme=newTheme;
    },


  },
});


export default themeSlice.reducer;
export const { toggleTheme} = themeSlice.actions;